import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../../contexts/AuthContext';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const generateMonths = () => {
  const months = [];
  const start = new Date(2024, 3, 1);
  const end   = new Date(2027, 11, 1);
  let cur = new Date(start);
  while (cur <= end) {
    const y = cur.getFullYear();
    const m = String(cur.getMonth() + 1).padStart(2, '0');
    months.push(`${y}-${m}`);
    cur.setMonth(cur.getMonth() + 1);
  }
  return months;
};

const MONTHS = generateMonths();

export default function Misc() {
  const { user } = useContext(AuthContext);
  const headers = { Authorization: `Bearer ${user?.token}` };
  const navigate = useNavigate();

  const [fromDate, setFromDate]           = useState('');
  const [toDate, setToDate]               = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [loading, setLoading]             = useState(false);
  const [error, setError]                 = useState('');
  const [success, setSuccess]             = useState('');

  useEffect(() => {
    const now = new Date();
    const cur = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    setSelectedMonth(MONTHS.includes(cur) ? cur : MONTHS[0]);
  }, []);

  const clearMessages = () => { setError(''); setSuccess(''); };

  const create6DBiweekly = async () => {
    if (!fromDate || !toDate) { setError('Please select both From and To dates.'); return; }
    clearMessages();
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/miscellaneous/6d-Biweekly`, {
        params: { from_date: fromDate, to_date: toDate },
        headers,
      });
      setSuccess(`Order ${res.data.inserted_order_no} created successfully.`);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create 6D Biweekly Order.');
    } finally {
      setLoading(false);
    }
  };

  const copySalary = async () => {
    if (!selectedMonth) { setError('Please select a month.'); return; }
    clearMessages();
    setLoading(true);
    try {
      const res = await axios.post(
        `${API_URL}/expenses/copy-prev-month-salary`,
        { month: selectedMonth },
        { headers },
      );
      setSuccess(res.data.message || 'Salary copied successfully.');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to copy salary.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '1.5rem', maxWidth: 600 }}>
      <h2 style={{ marginBottom: '1.25rem', fontSize: '1.25rem', color: '#2c3e50' }}>Miscellaneous</h2>

      {error   && <div style={{ background: '#fee', color: '#c33', border: '1px solid #fcc', borderRadius: 6, padding: '0.6rem 1rem', marginBottom: '1rem' }}>{error}</div>}
      {success && <div style={{ background: '#efe', color: '#2a7a2a', border: '1px solid #cfc', borderRadius: 6, padding: '0.6rem 1rem', marginBottom: '1rem' }}>{success}</div>}

      {/* 6D Biweekly */}
      <section style={{ background: '#fff', border: '1px solid #e0e0e0', borderRadius: 8, padding: '1.25rem', marginBottom: '1.5rem' }}>
        <h3 style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '1rem', color: '#333' }}>Create 6D Biweekly Order</h3>
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', alignItems: 'flex-end' }}>
          <div>
            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, marginBottom: 4, color: '#555' }}>From Date</label>
            <input
              type="date"
              value={fromDate}
              onChange={e => setFromDate(e.target.value)}
              style={{ padding: '0.45rem 0.65rem', border: '1px solid #ccc', borderRadius: 6, fontSize: '0.875rem' }}
            />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, marginBottom: 4, color: '#555' }}>To Date</label>
            <input
              type="date"
              value={toDate}
              onChange={e => setToDate(e.target.value)}
              style={{ padding: '0.45rem 0.65rem', border: '1px solid #ccc', borderRadius: 6, fontSize: '0.875rem' }}
            />
          </div>
          <button
            onClick={create6DBiweekly}
            disabled={loading}
            style={{ padding: '0.5rem 1.1rem', background: 'linear-gradient(135deg,#D84315,#F57C00)', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 600, fontSize: '0.875rem', cursor: 'pointer' }}
          >
            {loading ? 'Working…' : 'Create Order'}
          </button>
        </div>
      </section>

      {/* Invoices */}
      <section style={{ background: '#fff', border: '1px solid #e0e0e0', borderRadius: 8, padding: '1.25rem', marginBottom: '1.5rem' }}>
        <h3 style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '1rem', color: '#333' }}>Invoices</h3>
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate('/bank/invoices')}
            style={{ padding: '0.5rem 1.1rem', background: 'linear-gradient(135deg,#D84315,#F57C00)', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 600, fontSize: '0.875rem', cursor: 'pointer' }}
          >
            Invoices
          </button>
          <button
            onClick={() => navigate('/bank/pay-expenses')}
            style={{ padding: '0.5rem 1.1rem', background: '#27ae60', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 600, fontSize: '0.875rem', cursor: 'pointer' }}
          >
            Pay Expenses
          </button>
        </div>
      </section>

      {/* Copy Salary */}
      <section style={{ background: '#fff', border: '1px solid #e0e0e0', borderRadius: 8, padding: '1.25rem' }}>
        <h3 style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '1rem', color: '#333' }}>Copy Salary</h3>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-end', flexWrap: 'wrap' }}>
          <div>
            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, marginBottom: 4, color: '#555' }}>Month</label>
            <select
              value={selectedMonth}
              onChange={e => setSelectedMonth(e.target.value)}
              style={{ padding: '0.45rem 0.65rem', border: '1px solid #ccc', borderRadius: 6, fontSize: '0.875rem' }}
            >
              {MONTHS.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>
          <button
            onClick={copySalary}
            disabled={loading || !selectedMonth}
            style={{ padding: '0.5rem 1.1rem', background: 'linear-gradient(135deg,#D84315,#F57C00)', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 600, fontSize: '0.875rem', cursor: 'pointer' }}
          >
            {loading ? 'Working…' : 'Copy Salary'}
          </button>
        </div>
      </section>
    </div>
  );
}
